module.exports = __webpack_public_path__ + "img/1 (23).bff0fbc9.png";